function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/perfect-week");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 44.9999297 0 44.9999297 47.9999652 0 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 44.9999297 0 44.9999297 44.5217043 0 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0.00010546875 0 45 0 45 44.5217043 0.00010546875 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-217.000000, -777.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/perfect-week",
  transform: "translate(217.000000, 777.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999297,47.9999652 L22.4999297,47.9999652 C10.0736016,47.9999652 -7.03125e-05,38.0333565 -7.03125e-05,25.7390957 L-7.03125e-05,4.17387826 C-7.03125e-05,1.86883478 1.888875,-3.47826087e-05 4.21867969,-3.47826087e-05 L40.7811797,-3.47826087e-05 C43.1109844,-3.47826087e-05 44.9999297,1.86883478 44.9999297,4.17387826 L44.9999297,25.7390957 C44.9999297,38.0333565 34.9262578,47.9999652 22.4999297,47.9999652",
  id: "Fill-1",
  fill: "#8E9FA8",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999297,44.5217043 L22.4999297,44.5217043 C10.0736016,44.5217043 -7.03125e-05,34.5550957 -7.03125e-05,22.2608348 L-7.03125e-05,4.17387826 C-7.03125e-05,1.86883478 1.888875,-3.47826087e-05 4.21867969,-3.47826087e-05 L40.7811797,-3.47826087e-05 C43.1109844,-3.47826087e-05 44.9999297,1.86883478 44.9999297,4.17387826 L44.9999297,22.2608348 C44.9999297,34.5550957 34.9262578,44.5217043 22.4999297,44.5217043",
  id: "Fill-4",
  fill: "#D6E4EF",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813555,-3.47826087e-05 L4.21885547,-3.47826087e-05 C1.88905078,-3.47826087e-05 0.00010546875,1.86883478 0.00010546875,4.17387826 L0.00010546875,22.2608348 C0.00010546875,34.5550957 10.0734258,44.5217043 22.5001055,44.5217043 L22.5001055,44.5217043 C34.9264336,44.5217043 45.0001055,34.5550957 45.0001055,22.2608348 L45.0001055,4.17387826 C45.0001055,1.86883478 43.1111602,-3.47826087e-05 40.7813555,-3.47826087e-05 M40.7813555,4.17387826 L40.7813555,22.2608348 C40.7813555,32.2340522 32.580457,40.3477913 22.5001055,40.3477913 C12.4197539,40.3477913 4.21885547,32.2340522 4.21885547,22.2608348 L4.21885547,4.17387826 L40.7813555,4.17387826",
  id: "Fill-7",
  fill: "#B6C4CE",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.9049766,31.7419826 L16.0950938,31.7419826 C14.1534141,31.7419826 12.5794688,30.1847652 12.5794688,28.2637217 L12.5794688,15.5899826 C12.5794688,13.6689391 14.1534141,12.1117217 16.0950938,12.1117217 L28.9049766,12.1117217 C30.8466563,12.1117217 32.4206016,13.6689391 32.4206016,15.5899826 L32.4206016,28.2637217 C32.4206016,30.1847652 30.8466563,31.7419826 28.9049766,31.7419826",
  id: "Fill-10",
  fill: "#B6C4CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9049766,29.9017043 L16.0950938,29.9017043 C14.1534141,29.9017043 12.5794688,28.344487 12.5794688,26.4234435 L12.5794688,13.7497043 C12.5794688,11.8286609 14.1534141,10.2714435 16.0950938,10.2714435 L28.9049766,10.2714435 C30.8466563,10.2714435 32.4206016,11.8286609 32.4206016,13.7497043 L32.4206016,26.4234435 C32.4206016,28.344487 30.8466563,29.9017043 28.9049766,29.9017043",
  id: "Fill-12",
  fill: "#F7FAFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5794687,16.7125217 L12.5794687,13.3386087 C12.5794687,11.6446957 13.9674375,10.2714783 15.6795469,10.2714783 L29.3205234,10.2714783 C31.0326328,10.2714783 32.4206016,11.6446957 32.4206016,13.3386087 L32.4206016,16.7125217 L12.5794687,16.7125217 Z",
  id: "Fill-14",
  fill: "#F76988"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2827266,13.264487 L18.2827266,13.264487 C17.7690937,13.264487 17.3524922,12.8526609 17.3524922,12.3441391 L17.3524922,9.65787826 C17.3524922,9.14970435 17.7690937,8.73787826 18.2827266,8.73787826 C18.7963594,8.73787826 19.2129609,9.14970435 19.2129609,9.65787826 L19.2129609,12.3441391 C19.2129609,12.8526609 18.7963594,13.264487 18.2827266,13.264487",
  id: "Fill-16",
  fill: "#B6C4CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7173086,13.264487 L26.7173086,13.264487 C26.2036758,13.264487 25.7870742,12.8526609 25.7870742,12.3441391 L25.7870742,9.65787826 C25.7870742,9.14970435 26.2036758,8.73787826 26.7173086,8.73787826 C27.2309414,8.73787826 27.647543,9.14970435 27.647543,9.65787826 L27.647543,12.3441391 C27.647543,12.8526609 27.2309414,13.264487 26.7173086,13.264487",
  id: "Fill-18",
  fill: "#B6C4CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8280977,26.2168348 L22.5030586,21.3545739 L21.1614961,26.2168348 C21.0567305,26.5855304 20.9737617,26.8502261 20.9125898,27.0105739 C20.8510664,27.1709217 20.7438398,27.3145739 20.5909102,27.4418783 C20.4379805,27.5691826 20.2347773,27.6328348 19.9816523,27.6328348 C19.7766914,27.6328348 19.6079414,27.5949217 19.4757539,27.5194435 C19.3432148,27.4439652 19.2359883,27.3368348 19.1540742,27.1987478 C19.0721602,27.060313 19.0050117,26.8961391 18.9526289,26.7062261 C18.9005977,26.516313 18.8541914,26.340313 18.8130586,26.1778783 L17.4486445,20.7184 C17.367082,20.4011826 17.3259492,20.1597913 17.3259492,19.9938783 C17.3259492,19.7834435 17.4001289,19.6067478 17.549543,19.4627478 C17.6986055,19.3187478 17.8828242,19.2470957 18.1029023,19.2470957 C18.4048945,19.2470957 18.6077461,19.3430957 18.7125117,19.5347478 C18.8169258,19.7264 18.9079805,20.0050087 18.9863789,20.3698783 L20.0600508,25.1048348 L21.2616914,20.6742261 C21.3513398,20.3350957 21.4314961,20.0766609 21.5021602,19.8996174 C21.5731758,19.7225739 21.6888398,19.5698783 21.8491523,19.4408348 C22.0091133,19.3114435 22.227082,19.2470957 22.5030586,19.2470957 C22.7825508,19.2470957 22.9998164,19.3142261 23.1545039,19.4488348 C23.3091914,19.5834435 23.416418,19.7302261 23.4761836,19.888487 C23.5355977,20.0470957 23.6157539,20.3090087 23.7163008,20.6742261 L24.929543,25.1048348 L26.0032148,20.3698783 C26.0548945,20.1229217 26.1044648,19.9291826 26.1512227,19.7890087 C26.1976289,19.6488348 26.2777852,19.5236174 26.3916914,19.4130087 C26.5052461,19.3024 26.6701289,19.2470957 26.8863398,19.2470957 C27.1025508,19.2470957 27.2860664,19.3180522 27.4372383,19.4599652 C27.5880586,19.6018783 27.6636445,19.7799652 27.6636445,19.9938783 C27.6636445,20.1448348 27.6225117,20.3865739 27.5405977,20.7184 L26.1765352,26.1778783 C26.0830195,26.5469217 26.0056758,26.8168348 25.9445039,26.9886609 C25.8829805,27.1597913 25.7782148,27.3104 25.6312617,27.4390957 C25.483957,27.5681391 25.2761836,27.6328348 25.0079414,27.6328348 C24.7544648,27.6328348 24.5512617,27.5702261 24.398332,27.4446609 C24.2454023,27.3194435 24.1392305,27.1782261 24.0798164,27.0217043 C24.0200508,26.8648348 23.9363789,26.5966609 23.8280977,26.2168348",
  id: "Fill-20",
  fill: "#0A0A0A"
})))));

var SvgPerfectWeek = function SvgPerfectWeek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerfectWeek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perfect-week.7b6d80bd.svg";
export { ForwardRef as ReactComponent };